/**
 * Created by david.vanoni@coplex.com on 12/11/17.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { calculatePercentage } from '../../../lib/utils.js';

const InitiativeCompletionColumn = ({ initiative }) => {
  const { completionTracked, participationCount, participationCompletedCount } =
    initiative;

  if (!completionTracked) {
    return (
      <td>
        <strong>—</strong>
      </td>
    );
  }

  const completionPercentage = calculatePercentage(
    participationCompletedCount,
    participationCount
  );

  return (
    <td>
      <div className="strong">{completionPercentage}%</div>
      <div className="text-details">
        {participationCompletedCount} /{participationCount}
      </div>
    </td>
  );
};

InitiativeCompletionColumn.propTypes = {
  initiative: PropTypes.shape({
    completionTracked: PropTypes.bool,
    participationCount: PropTypes.number,
    participationCompletedCount: PropTypes.number,
  }).isRequired,
};

export default InitiativeCompletionColumn;
